const ForeverAndEverAmen = [
	'[Verse 1]',
	"You may think that I'm talking foolish",
	"You've heard that I'm wild and I'm free",
	'You may wonder how I can promise you now',
	'This love that I feel for you always will be',
	"But you're not just time that I'm killing",
	"I'm no longer one of those guys",
	'As sure as I live this love that I give',
	'Is gonna be yours until the day that I die, oh baby',
	'',
	'[Chorus]',
	"I'm gonna love you forever, forever and ever amen",
	'As long as old men sit and talk about the weather',
	'As long as old women sit and talk about old men',
	"If you wonder how long I'll be faithful",
	"I'll be happy to tell you again",
	"I'm gonna love you forever and ever, forever and ever, amen",
	'',
	'[Verse 2]',
	'They say time takes its toll on a body',
	"Makes the young girl's brown hair turn grey",
	"But honey, I don't care, I ain't in love with your hair",
	"And if it all fell out well, I'd love you anyway",
	'They say time can play tricks on a memory',
	'Make people forget things they knew',
	"Well, it's easy to see it's happening to me",
	"I've already forgotten every woman but you, oh darlin'",
	'',
	'[Chorus]',
	"I'm gonna love you forever, forever and ever amen",
	'As long as old men sit and talk about the weather',
	'As long as old women sit and talk about old men',
	"If you wonder how long I'll be faithful",
	'Just listen to how this song ends',
	'',
	'[Outro]',
	"I'm gonna love you forever and ever, forever and ever, amen",
	"I'm gonna love you forever and ever, forever and ever",
	'Forever and ever, forever and ever ... A - men',
];

export default ForeverAndEverAmen;
